/**
 * Format a date string according to the user's locale
 * @param {string} dateString - ISO date string (e.g., "2024-03-15T10:30:00Z" or "2024-03-15")
 * @param {string} locale - Locale string (e.g., "en-GB", "fr-FR", "de-DE")
 * @returns {string} Formatted date string according to locale
 */
export const formatDate = (dateString, locale = 'en-GB') => {
    if (!dateString) return '';
    
    try {
        const date = new Date(dateString);
        
        if (isNaN(date.getTime())) {
            console.error('Invalid date string:', dateString);
            return dateString;
        }
        
        return date.toLocaleDateString(locale, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
    } catch (error) {
        console.error('Error formatting date:', error);
        return dateString;
    }
};
